import * as React from "react";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import { MessageBar, MessageBarType } from "@fluentui/react/lib/MessageBar";
import { useEffect, useState } from "react"
import { useHistory } from "react-router";
import { _Styles } from '../../content/styles/Page.styles';
import { AAdAuth } from "./authentication";
import { UIControlsText } from "../../content/UIControlsText";
import { Stack } from "office-ui-fabric-react";
import { getRuleValidationMessage, getEntityDataFromSession } from '../../components/shared/common/util';
import { SessionStorageConsts } from '../../models/SessionStorageConsts';
import { MessageTypeText } from '../../models/MessageTypeText';

const sessionResourceData = getEntityDataFromSession<any>(SessionStorageConsts.resourceStrings);

export const LoginPage: React.FunctionComponent = () => {
    var redirectURL: any = "";
    let history = useHistory();
    let rslrAuthUrl = process.env.REACT_APP_RSLR_LOGIN_API_URI || "";
    const showSurfaceTermsBanner: boolean = process.env.REACT_APP_SURFACE_TERMS_BANNER_SHOW === 'true';
    const surfaceTermsBannerDate = process.env.REACT_APP_SURFACE_TERMS_BANNER_DATE;
    const partnerCenterUrl = process.env.REACT_APP_PARTNER_CENTER_URL;
    const additionalOnboardingInfoUrl = process.env.REACT_APP_ADDITIONAL_ONBOARDING_INFO_URL;
    const [showBanner, setShowSurfaceTermsBanner] = useState(showSurfaceTermsBanner);
    
    useEffect(() => {
        redirectURL = window.location.href;
        console.log("current url:", redirectURL)
        if (redirectURL.includes("LoginWithAAD")) {
            history.push("/AAdAuth");
        }
    });

    function loginRSLR() {
        window.location.href = rslrAuthUrl;
    }

    return (
        <div>
            <div className={_Styles.contentStyle}>
                <div className={_Styles.LoginOuterPanel}>
                    {/* Surface Terms Expiration Banner - Configurable */}
                    {showBanner && (
                        <div className={_Styles.bannerNotificationStyle}>
                            <MessageBar
                                messageBarType={MessageBarType.info}
                                isMultiline={true}
                                dismissButtonAriaLabel="Close"
                                style={{ fontSize: '15px' }}
                            >
                                <div style={{ fontSize: '15px' }}>
                                    <div
                                        style={{ fontSize: '15px' }}
                                        dangerouslySetInnerHTML={{
                                            __html: getRuleValidationMessage(
                                                sessionResourceData,
                                                MessageTypeText.FieldLabelText,
                                                "SurfaceTermsExpirationBannerText",
                                                UIControlsText.SurfaceTermsExpirationBannerText
                                            )
                                                .replaceAll("{0}", `<span style="color: red; font-weight: bold; font-size: 15px;">${surfaceTermsBannerDate || "TBD"}</span>`)
                                                .replaceAll("{PartnerCenterLink}", `<a href="${process.env.REACT_APP_PARTNER_CENTER_URL}" target="_blank" rel="noopener noreferrer" style="font-size: 15px;">${getRuleValidationMessage(sessionResourceData, MessageTypeText.FieldLabelText, "PartnerCenterText", UIControlsText.PartnerCenterText)}</a>`)
                                        }}
                                    />
                                    <div style={{ marginTop: '8px', fontSize: '15px' }}>
                                        <div>
                                            {UIControlsText.AdditionalOnboardingInfoText} - {' '}
                                            <a 
                                                href={additionalOnboardingInfoUrl} 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                                style={{ fontSize: '15px' }}
                                            >
                                                {UIControlsText.AdditionalOnboardingLinkText}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </MessageBar>
                        </div>
                    )}
                    <div className={_Styles.LoginInnerPanel}>
                        <h1 className={_Styles.LoginInnerPanelh1}>{getRuleValidationMessage(sessionResourceData, MessageTypeText.FieldLabelText, "Welcome", UIControlsText.Welcome)}</h1>
                        <h2 className={_Styles.LoginInnerPanelh2}>{getRuleValidationMessage(sessionResourceData, MessageTypeText.FieldLabelText, "MDPP", UIControlsText.MDPP)}</h2>
                        <div className={_Styles.LoginInnerSign}>
                            <h2 className={_Styles.LoginInnerSignh2}>{getRuleValidationMessage(sessionResourceData, MessageTypeText.FieldLabelText, "SigninMessage", UIControlsText.SigninMessage)}</h2>
                            <h4 className={_Styles.LoginInnerSignh4}>
                                {getRuleValidationMessage(sessionResourceData, MessageTypeText.OpportunityValidationError, "WorkAccountDescription", UIControlsText.WorkAccountDescription)}
                                <Stack className={_Styles.LoginTextStyle}>
                                    <i>{getRuleValidationMessage(sessionResourceData, MessageTypeText.FieldPlaceHolderText, "SigninExample", UIControlsText.SigninExample)}</i>
                                </Stack>
                                <Stack className={_Styles.LoginTextStyle}>
                                    <span>{getRuleValidationMessage(sessionResourceData, MessageTypeText.FieldGuidanceText, "SigninGuidance", UIControlsText.SigninGuidance)}<a href="https://docs.microsoft.com/en-us/partner-center/azure-active-directory-tenants-and-partner-center" target="_blank">{getRuleValidationMessage(sessionResourceData, MessageTypeText.FieldGuidanceText, "ClickHere", UIControlsText.ClickHere)}</a></span>
                                </Stack>
                                <PrimaryButton
                                    title={getRuleValidationMessage(sessionResourceData, MessageTypeText.FieldLabelText, "Signin", UIControlsText.Signin)}
                                    text={getRuleValidationMessage(sessionResourceData, MessageTypeText.FieldLabelText, "Signin", UIControlsText.Signin)}
                                    ariaLabel={getRuleValidationMessage(sessionResourceData, MessageTypeText.FieldLabelText, "Signin", UIControlsText.Signin)}
                                    onClick={loginRSLR} />
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}